 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		114: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_uz","52":"lang_vi","53":"lang_zh_cn","54":"lang_zh_tw","55":"locale_ak","56":"locale_ar","57":"locale_be","58":"locale_bg","59":"locale_bs","60":"locale_ca","61":"locale_cs","62":"locale_da","63":"locale_de","64":"locale_el","65":"locale_en","66":"locale_es","67":"locale_et","68":"locale_fi","69":"locale_fil","70":"locale_fr","71":"locale_he","72":"locale_hi","73":"locale_hr","74":"locale_hu","75":"locale_id","76":"locale_is","77":"locale_it","78":"locale_ja","79":"locale_ka","80":"locale_kk","81":"locale_ko","82":"locale_ky","83":"locale_lt","84":"locale_lv","85":"locale_nl","86":"locale_pa","87":"locale_pl","88":"locale_pt","89":"locale_ro","90":"locale_ru","91":"locale_sk","92":"locale_sl","93":"locale_sq","94":"locale_sr","95":"locale_sr_cyrl_me","96":"locale_sv","97":"locale_sw","98":"locale_th","99":"locale_tr","100":"locale_uk","101":"locale_ur","102":"locale_uz","103":"locale_vi","104":"locale_zh","105":"loclae_af","106":"polyfills","108":"vendors~css-vars-ponyfill","109":"vendors~dompurify","110":"vendors~marked","111":"vendors~polyfills","113":"vendors~sentry"}[chunkId]||chunkId) + "." + {"0":"e052a76fdd20fcfbf695","2":"365c6488a36dd5833fba","3":"dd737dd129e8ac8573d5","4":"0e07f1a94af8083783e7","5":"edd9f3fd470f6c390392","6":"c89056b622ae5693bf22","7":"43ee1dc74718635bd942","8":"38537fbd34c611d956bf","9":"18a10df2987521db6e33","10":"c8199570742923880401","11":"ce991190ff243672986f","12":"8f38be6278fa93dc0ebc","13":"68b80a03f009ac1fd661","14":"847f7c19df2f3b4c9e04","15":"76a166c249116be656cc","16":"fd28aa0cf8015d1c14c1","17":"18bd705a487adb2e5fb0","18":"7030084b8e58a494d066","19":"42ed5f90305fa313cf9e","20":"273dd1ae68867eeb93ad","21":"f6f5f68838e787b2f8ed","22":"b07c0dd4ddbc6f421be6","23":"93802a827079c0461497","24":"cc549c478c9c0952ad95","25":"d20b9680af8f1cada0e9","26":"2dc9de43d91a6a5ceb9b","27":"6a621e51691c2878f59d","28":"46143a6a564d8640b6d6","29":"15522e9169cca1430bd1","30":"926fd35cb6984e7a2712","31":"7459f2909329ff5642e0","32":"c163db0030dccd17e0ce","33":"3acfcfdd0c77b398ffad","34":"4dcf712f662782e66a68","35":"575d8f071e115af27a7e","36":"9553af6a6fc76e7d6119","37":"47683c7d0c20c2ea2b3a","38":"e23b73be1c095b7e1385","39":"8852bc98c8fd03402e36","40":"4f802ebf447c6b232124","41":"9996a539babd5b501f12","42":"2a686e6f2692ac3fe1b2","43":"7561aff9b73c2652ceab","44":"86d48ae2f7915745fbef","45":"7647f897b9fb1760bc8e","46":"55147a181c8ff9ef6730","47":"c2a860ff7dff2fcc9040","48":"aca9831f4b4801e110c5","49":"df485a5528a514bd126b","50":"d23d8ab805a613854f0f","51":"400d6c199dc98265a511","52":"ba753f446ea44c4b0a74","53":"a2ba830f36903231e782","54":"e82a211a34a101d915b5","55":"ebad069e57214bc82978","56":"a2f7b3e14ce604504efe","57":"5e4e5a79a21ec64bffc2","58":"a13e009896e87455a501","59":"f3c8e61ccd16bf409efe","60":"fc50f4e64b5e5c7063c1","61":"576b804c8cc037a0f695","62":"2e69d2e6b477c9d98b3a","63":"0dbbc5eed69ff44b0cce","64":"2f187a75afdc982532f0","65":"a4eb67230b7e78d14583","66":"5562bb8bfa21615a18c8","67":"2d0fd68ad7fda83d3bf0","68":"587771f502e6ea15f74b","69":"22fa58a4990dddc3cb14","70":"0ee732f52aaa1b35b35f","71":"4531f91dd762b349c206","72":"b2e8f8388b3e4e31c5dd","73":"ca65667acccad48091da","74":"49363ff13fbff9951f60","75":"32d0da1f3b17ff53f081","76":"9ead231e08fb4391ca31","77":"6082b1e7332208bd8378","78":"e339c1b8614dfed10bd2","79":"58ea564da40c0d25da3a","80":"ef96ccf0be20eec3e9a2","81":"34d08fa3f58ea79ebe9a","82":"e9cbd90a9f7a557ca6fa","83":"fd1df64a62b8506101e1","84":"840be967f2fcda2c2607","85":"1c67aa45366459980e06","86":"7def7096f7cb69d9d6d9","87":"59d10c80969ab9f2d468","88":"14ae9a7b65b62d3f5632","89":"dd4a908496aedb101cd3","90":"3be047956c998d0cf97c","91":"5a27c394fb18dff0bbc7","92":"2bf5f1d1db301fda0148","93":"015cf926197985195715","94":"b1a6f38282a67a208eb0","95":"9431283b8c54c8ae0230","96":"c163ffabc25d2a590cc3","97":"ca47b48a3622c94e9eca","98":"9435df08d648e0f4193f","99":"9efc2ba2ee46648bd638","100":"9331c50a110e858bf014","101":"08da58c47ebc959bd614","102":"8c07bca53d8128cc9133","103":"24259e508e82554d0d2b","104":"5e23e92619e634f7b76f","105":"9f343e609b3b32d466b7","106":"16b290354d60e40cb952","108":"fe3e69f178fea6a027e8","109":"3dd71df53ac00858df4a","110":"71320f5d1c68c120a3df","111":"23c23d5ff44c80c14e8f","113":"630f35db65d5fde78b1a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/release-v0.1.258/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 100);
